<template>
  <v-container class="pt-0">
    <v-row justify="center">
      <v-dialog
        v-model="open"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Grupos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              dark
              text
              @click="saveDialog"
              :disabled="itemsGrupos.length === 0"
            >
              <v-icon class="mr-2">mdi-content-save-edit</v-icon> Guardar
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <grupos-agregados :grupos="grupos" />

              <v-card>
                <v-card-title class="secondary py-1"
                  >Agregar grupo</v-card-title
                >
                <v-card-text>
                  <v-row>
                    <v-col cols="6" sm="3" md="2">
                      <v-select
                        v-model="datos.semestre"
                        :items="semPar ? par : impar"
                        label="Semestre"
                        required
                      />
                    </v-col>
                    <v-col cols="6" sm="2" md="2">
                      <v-select
                        v-model="datos.letra"
                        :items="itemsGrupos"
                        label="Grupo"
                        required
                        @change="carreraGrupo"
                      />
                    </v-col>
                    <v-col cols="12" sm="3" md="2">
                      <v-select
                        v-model="datos.turno"
                        :items="[
                          { text: 'Vespertino', value: 'TV' },
                          { text: 'Matutino', value: 'TM' },
                        ]"
                        label="Turno"
                        required
                      />
                    </v-col>
                    <v-col cols="12" sm="4" md="6">
                      <v-select
                        v-model="datos.carrera_id"
                        :items="itemsCarreras"
                        label="Carrera"
                        required
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import api from "@/api";
import GruposAgregados from "./GruposAgregados";

export default {
  name: "GrupoDialog",

  components: { GruposAgregados },

  props: {
    open: Boolean,
    datos: Object,
    grupos: Object,
    semPar: Boolean,
  },

  data: () => ({
    impar: [
      { text: "Primero", value: "1" },
      { text: "Tercero", value: "3" },
      { text: "Quinto", value: "5" },
    ],
    par: [
      { text: "Segundo", value: "2" },
      { text: "Cuarto", value: "4" },
      { text: "Sexto", value: "6" },
    ],
    carreras: null,
  }),

  computed: {
    itemsCarreras() {
      const items = [];
      for (let c in this.carreras) {
        items.push({
          text:
            this.carreras[c].nombre +
            " (" +
            this.carreras[c].plan_estudios +
            ")",
          value: this.carreras[c].id,
        });
      }
      return items;
    },

    itemsGrupos() {
      if (this.datos.semestre == 1) {
        return this.grupos1;
      } else if (this.datos.semestre == 2) {
        return this.grupos2;
      } else if (this.datos.semestre == 3) {
        return this.grupos3;
      } else if (this.datos.semestre == 4) {
        return this.grupos4;
      } else if (this.datos.semestre == 5) {
        return this.grupos5;
      } else if (this.datos.semestre == 6) {
        return this.grupos6;
      }
    },

    grupos1() {
      if (!this.semPar) {
        let items = [
          { text: "- A -", value: "A" },
          { text: "- B -", value: "B" },
          { text: "- C -", value: "C" },
          { text: "- D -", value: "D" },
          { text: "- E -", value: "E" },
          { text: "- F -", value: "F" },
          { text: "- G -", value: "G" },
          { text: "- H -", value: "H" },
        ];
        for (let g in this.grupos) {
          if (this.grupos[g].semestre == 1) {
            if (this.grupos[g].turno == this.datos.turno) {
              for (let i = 0; i < items.length; i++) {
                if (this.grupos[g].letra == items[i].value) {
                  items.splice(i, 1);
                  break;
                }
              }
            }
          }
          if (this.grupos[g].semestre > 1) break;
        }
        return items;
      } else return null;
    },

    grupos2() {
      if (this.semPar) {
        let items = [
          { text: "- A -", value: "A" },
          { text: "- B -", value: "B" },
          { text: "- C -", value: "C" },
          { text: "- D -", value: "D" },
          { text: "- E -", value: "E" },
          { text: "- F -", value: "F" },
          { text: "- G -", value: "G" },
          { text: "- H -", value: "H" },
        ];
        for (let g in this.grupos) {
          if (this.grupos[g].semestre == 2) {
            if (this.grupos[g].turno == this.datos.turno) {
              for (let i = 0; i < items.length; i++) {
                if (this.grupos[g].letra == items[i].value) {
                  items.splice(i, 1);
                  break;
                }
              }
            }
          }
          if (this.grupos[g].semestre > 2) break;
        }
        return items;
      } else return null;
    },

    grupos3() {
      if (!this.semPar) {
        let items = [
          { text: "- A -", value: "A" },
          { text: "- B -", value: "B" },
          { text: "- C -", value: "C" },
          { text: "- D -", value: "D" },
          { text: "- E -", value: "E" },
          { text: "- F -", value: "F" },
          { text: "- G -", value: "G" },
          { text: "- H -", value: "H" },
        ];
        for (let g in this.grupos) {
          if (this.grupos[g].semestre == 3) {
            if (this.grupos[g].turno == this.datos.turno) {
              for (let i = 0; i < items.length; i++) {
                if (this.grupos[g].letra == items[i].value) {
                  items.splice(i, 1);
                  break;
                }
              }
            }
          }
          if (this.grupos[g].semestre > 3) break;
        }
        return items;
      } else return null;
    },

    grupos4() {
      if (this.semPar) {
        let items = [
          { text: "- A -", value: "A" },
          { text: "- B -", value: "B" },
          { text: "- C -", value: "C" },
          { text: "- D -", value: "D" },
          { text: "- E -", value: "E" },
          { text: "- F -", value: "F" },
          { text: "- G -", value: "G" },
          { text: "- H -", value: "H" },
        ];
        for (let g in this.grupos) {
          if (this.grupos[g].semestre == 4) {
            if (this.grupos[g].turno == this.datos.turno) {
              for (let i = 0; i < items.length; i++) {
                if (this.grupos[g].letra == items[i].value) {
                  items.splice(i, 1);
                  break;
                }
              }
            }
          }
          if (this.grupos[g].semestre > 4) break;
        }
        return items;
      } else return null;
    },

    grupos5() {
      if (!this.semPar) {
        let items = [
          { text: "- A -", value: "A" },
          { text: "- B -", value: "B" },
          { text: "- C -", value: "C" },
          { text: "- D -", value: "D" },
          { text: "- E -", value: "E" },
          { text: "- F -", value: "F" },
          { text: "- G -", value: "G" },
          { text: "- H -", value: "H" },
        ];
        for (let g in this.grupos) {
          if (this.grupos[g].semestre == 5) {
            if (this.grupos[g].turno == this.datos.turno) {
              for (let i = 0; i < items.length; i++) {
                if (this.grupos[g].letra == items[i].value) {
                  items.splice(i, 1);
                  break;
                }
              }
            }
          }
          if (this.grupos[g].semestre > 5) break;
        }
        return items;
      } else return null;
    },

    grupos6() {
      if (this.semPar) {
        let items = [
          { text: "- A -", value: "A" },
          { text: "- B -", value: "B" },
          { text: "- C -", value: "C" },
          { text: "- D -", value: "D" },
          { text: "- E -", value: "E" },
          { text: "- F -", value: "F" },
          { text: "- G -", value: "G" },
          { text: "- H -", value: "H" },
        ];
        for (let g in this.grupos) {
          if (this.grupos[g].semestre == 6) {
            if (this.grupos[g].turno == this.datos.turno) {
              for (let i = 0; i < items.length; i++) {
                if (this.grupos[g].letra == items[i].value) {
                  items.splice(i, 1);
                  break;
                }
              }
            }
          }
          if (this.grupos[g].semestre > 6) break;
        }
        return items;
      } else return null;
    },
  },

  methods: {
    closeDialog() {
      this.$emit("exit");
    },

    saveDialog() {
      this.$emit("save");
    },

    carreraGrupo() {
      let found = false;
      let iniciales = "";
      let idx = 0;
      switch (this.datos.letra) {
        case "A":
          iniciales = "Adm";
          break;
        case "B":
          iniciales = "Log";
          break;
        case "C":
          iniciales = "Con";
          break;
        case "D":
          iniciales = "Ofi";
          break;
        case "E":
          iniciales = "Pro";
          break;
        case "F": //
        case "H":
          iniciales = "Pre";
          break;
        case "G":
          iniciales = "Ser";
          break;
        case "H":
          iniciales = "Adm";
          break;
      }
      for (idx in this.itemsCarreras) {
        if (iniciales == this.itemsCarreras[idx].text.substr(0, 3)) {
          found = true;
          break;
        }
      }
      if (found) {
        this.datos.carrera_id = this.itemsCarreras[idx].value;
      }
    },

    async getCarreras() {
      const response = await api.send({
        table: "carreras",
        action: "get",
        scope: "all",
        sort: "nombre, plan_estudios",
      });
      if (response.status == 200) {
        this.carreras = response.data;
      } else this.carreras = null;
    },
  },

  watch: {
    itemsGrupos(val) {
      this.datos.letra =
        this.itemsGrupos.length > 0 ? this.itemsGrupos[0].value : "";
      this.carreraGrupo();
    },
  },

  async mounted() {
    await this.getCarreras();
    this.datos.letra =
      this.itemsGrupos.length > 0 ? this.itemsGrupos[0].value : "";
    this.carreraGrupo();
  },
};
</script>
